import React,{ useState, useEffect } from "react";
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { 
    Button,
} from 'antd';

function CountdownTimer({ handleTimerComplete, serviceObj }) {
    const [isPlaying, setIsPlaying] = useState( true );

    useEffect(() => {})

    return (
        <>
            <CountdownCircleTimer
                    isPlaying
                    duration={10}
                    colors={['#1C4A12']}
                    size={100}
                    className="countdown-circle-timer"
                    onComplete={ () => handleTimerComplete( serviceObj )}
                >
                    {({ remainingTime }) => remainingTime} 
            </CountdownCircleTimer> 
        </>
    )
}

export default CountdownTimer